

export const API_SVC_HOST = window.appConfig.APIURL || JSON.stringify(process.env.VUE_APP_URL);/* baseUrl */
